import { pick } from 'lodash-es';

import { BASE_SIZE } from '../constant';

export const SWITCH_SIZE = pick(BASE_SIZE, 'MD');

export const SWITCH_DEFAULT_SIZE = SWITCH_SIZE.MD;
